import { matchPath, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { processReactRoute } from '@Services/PageTitle';
import { paths } from '@AppRoutes/constants';

function PageTitleUpdater() {
  const location = useLocation();
  const params = useParams(); // Route params
  const searchParams = new URLSearchParams(location.search); // Query params

  const getRoutePattern = (pathname) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const [, pattern] of Object.entries(paths)) {
      const match = matchPath(pathname, {
        path: pattern,
        exact: true,
        strict: false,
      });
      if (match) {
        return match;
      }
    }

    return null;
  };

  useEffect(() => {
    const matchedRoute = getRoutePattern(location.pathname);
    if (!matchedRoute) {
      return;
    }
    processReactRoute({
      path: matchedRoute.path,
      params: {
        ...params,
        ...searchParams,
        ...location.state,
        ...matchedRoute.params,
      },
    });
  }, [location.pathname, location.search, params]);

  return null;
}

export default PageTitleUpdater;
